module.exports = __webpack_public_path__ + "static/specshome-089e6a8266aabbcbb3b173719c1c237b.png";